import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MaterialList from "./MaterialList";
import { getBusinessItemList } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  businessItemData: state.businessItemReducer.businessItemList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBusinessItemList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MaterialList);